export enum OmNamRequestStatus {
    SAVED = 'saved',
    SUBMITTED = 'submitted',
    PENDING_CUSTOMER_ACTION = 'pending-customer-action',
    REFERRED_OUT = 'referred-out',
    UNDER_REVIEW = 'under-review',
    CLOSED = 'closed'
}

export const omNamStateToDisplayName = new Map<OmNamRequestStatus, string>([
    [OmNamRequestStatus.SAVED, 'saved'],
    [OmNamRequestStatus.SUBMITTED, 'submitted'],
    [OmNamRequestStatus.PENDING_CUSTOMER_ACTION, 'pending requestor response'],
    [OmNamRequestStatus.REFERRED_OUT, 'referred out'],
    [OmNamRequestStatus.UNDER_REVIEW, 'under review'],
    [OmNamRequestStatus.CLOSED, 'closed']
]);
